class HaanOrderForm {

  constructor($elm) {
    this.INPUT_NAME_PATTERN = 'tx_stadtwerkehaancalculator_ordergas[order][%FIELD_NAME%]';
    this.currentFetchController = null;

    this.initDomElements($elm);
    this.currentStep = this.readCurrentStep();
    this.initCurrentStep();
  }

  initDomElements($elm) {
    this.domElements = {};
    this.domElements.main = $elm;
    this.domElements.form = this.domElements.main.find('form');
    this.domElements.submitButton = this.domElements.form.find(
        'button[type="submit"]');
  }

  readCurrentStep() {
    return parseInt(this.domElements.form.data('currentStep'), 10) || 1;
  }

  initCurrentStep() {
    const stepMethod = `initStep${this.currentStep}`;
    if (typeof this[stepMethod] === 'function') {
      this[stepMethod]();
    }
  }

  initStep1() {

    this.domElements.form.find(
        'input[name$="[consumption]"], input[name$="[productUid]"], input[name$="[measuringSystem]"]').
        on('change', this.onChangeFieldsStep1.bind(this));
  }

  onChangeFieldsStep1(event) {

    event.preventDefault();

    const focusedElement = document.activeElement;
    const focusedElementName = focusedElement ? focusedElement.getAttribute(
        'name') : null;

    if (this.currentFetchController) {
      this.currentFetchController.abort();
    }

    this.currentFetchController = new AbortController();

    const formData = new FormData(this.domElements.form[0]);

    formData.append('stayOnStep', 'true');

    fetch(this.domElements.form.attr('action'), {
      method: 'POST',
      body: formData,
      signal: this.currentFetchController.signal
    }).then(response => response.text()).then(html => {

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newForm = doc.querySelector('.calculator-order__form');

      if (newForm) {
        this.domElements.form.replaceWith(newForm);
        this.initDomElements(this.domElements.main);
        this.initCurrentStep();

        if (focusedElementName) {
          const elementToFocus = this.domElements.form.find(
              `[name="${focusedElementName}"]`);
          if (elementToFocus.length) {
            elementToFocus.focus();
          }
        }

        // const priceElement = newForm.querySelector('.calculator-order__price-summary');
        // const nextButton = newForm.querySelector('.form__action__next-button');
        //
        // if (priceElement && nextButton) {
        //   const price = parseFloat(priceElement.getAttribute('data-price') || '0');
        //
        //   console.log('price', price);
        //
        //   if (price === 0) {
        //     nextButton.style.display = 'none';
        //   } else {
        //     nextButton.style.display = '';
        //   }
        // }
      }

      this.currentFetchController = null;
    }).catch(error => {
      if (error.name !== 'AbortError') {
        console.error('Error submitting form:', error);
      }

      this.currentFetchController = null;
    });
  }

  initStep3() {

    this.domElements.differentDeliveryAddressCheckbox = this.domElements.form.find('input[name$="[differentDeliveryAddress]"]');

    this.domElements.differentDeliveryAddressFields = this.domElements.form.find('#differentDeliveryAddressFields');


    // Initial state
    if (this.domElements.differentDeliveryAddressCheckbox.is(':checked')) {
      this.domElements.differentDeliveryAddressFields.show();
    }

    this.domElements.differentDeliveryAddressCheckbox.on('change', event => {
      console.log('change');
      if (event.currentTarget.checked) {
        this.domElements.differentDeliveryAddressFields.show();
      } else {
        this.domElements.differentDeliveryAddressFields.hide();
      }
    });
  }

  initStep4() {

    this.domElements.directDebitRadio = this.domElements.form.find('#payment-direct-debit');
    this.domElements.transferRadio = this.domElements.form.find('#payment-transfer');
    this.domElements.bankAccountFields = this.domElements.form.find('#bank-account-fields');

    // Function to toggle bank account fields visibility
    const toggleBankAccountFields = () => {
      if (this.domElements.directDebitRadio.is(':checked')) {
        this.domElements.bankAccountFields.show();
      } else {
        this.domElements.bankAccountFields.hide();
      }
    };

    // Initial state
    toggleBankAccountFields();

    // Add event listeners
    this.domElements.directDebitRadio.on('change', toggleBankAccountFields);
    this.domElements.transferRadio.on('change', toggleBankAccountFields);
  }

  initStep5() {

    this.domElements.advertisingCheckbox = this.domElements.form.find('#advertising');
    this.domElements.advertisingOptions = this.domElements.form.find('#advertising-options');

    // Function to toggle advertising options visibility
    const toggleAdvertisingOptions = () => {
      if (this.domElements.advertisingCheckbox.is(':checked')) {
        this.domElements.advertisingOptions.show();
      } else {
        this.domElements.advertisingOptions.hide();
      }
    };

    // Initial state
    toggleAdvertisingOptions();

    // Add event listener
    this.domElements.advertisingCheckbox.on('change', toggleAdvertisingOptions);
  }

}

export default HaanOrderForm;
